const config = {
  // Buckets
  s3: process.env.VUE_APP_S3,
  images: process.env.VUE_APP_IMAGES,
  // Amplify
  region: process.env.VUE_APP_REGION,
  userPoolId: process.env.VUE_APP_USER_POOL_ID,
  userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
  // Endpoint GrGraphQL
  endPointGraphQL: process.env.VUE_APP_ENDPOINT_GRAPHQL,
  // CNPJ
  apiCNPJ: `${process.env.VUE_APP_API_BASE_URL}/${process.env.VUE_APP_API_STAGE}`,
  // Auth
  signIn: `${process.env.VUE_APP_API_GETAWAY_BASE_URL}/${process.env.VUE_APP_API_STAGE}/${process.env.VUE_APP_API_RESOURCE_SIGN_IN}`,
  signUp: `${process.env.VUE_APP_API_GETAWAY_BASE_URL}/${process.env.VUE_APP_API_STAGE}/${process.env.VUE_APP_API_RESOURCE_SIGN_UP}`,
  verifyUserExistsURL: `${process.env.VUE_APP_API_BASE_URL}/${process.env.VUE_APP_API_STAGE}/verify-user-exists`,
  // Send Email
  sendMailURL: `${process.env.VUE_APP_API_BASE_URL}/${process.env.VUE_APP_API_STAGE}/${process.env.VUE_APP_API_RESOURCE_SEND_MAIL}`,
  // Redis
  redis: `${process.env.VUE_APP_API_REDIS}/dev`
}

export { config }

export default {
  install (Vue) {
    Vue.appConfig = config
    Vue.prototype.$appConfig = config
  }
}
